import {
  SET_NAV_HEIGHT,
  SET_AGENT_DATA,
  SET_DISTANCE_FROM_TOP
} from '@/store/mutations.types';

import { processUserAgent } from '@/constants';
import { extractAppDeivceScreen } from '@/utils';

export default {
  namespaced: true,
  state: {
    // Navigation altitude
    navHeight: 0,
    phoneContentTopHeight: 0,
    phoneBottomSecurityHeight: 0,
    // Location of the status bar
    agentData: {
      top: 0,
      bottom: 0
    }
  },
  mutations: {
    // Method for Setting Navigation Altitude
    // ❗❗❗Only Navigator.vue components are provided for use, and other components are prohibited from being used❗❗❗
    [SET_NAV_HEIGHT](state, data) {
      state.navHeight = data;
      state.phoneContentTopHeight = data;
    },
    // Method for setting the height of the safety zone
    [SET_AGENT_DATA](state, data) {
      // Obtain the security zone height of iOS navigator
      const userAgent = navigator.userAgent;
      const result = extractAppDeivceScreen(processUserAgent(userAgent));
      state.agentData = result;
      state.phoneContentTopHeight = Number(data?.top ?? result.top);
      state.phoneBottomSecurityHeight = Number(data?.bottom ?? result.bottom);
    },
    // Set top distance
    [SET_DISTANCE_FROM_TOP](state, data) {
      state.phoneContentTopHeight = Number(state.agentData?.top ?? 0) + data;
    }
  }
};
